import { Actor, HttpAgent } from '@dfinity/agent';
import { idlFactory as niq_faucet_idl, canisterId as niq_faucet_id } from 'dfx-generated/niq_faucet';
function formatMoney(a, d){
    return (a).toFixed(d ?? 2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

const agent = new HttpAgent();
const niq_faucet = Actor.createActor(niq_faucet_idl, { agent, canisterId: niq_faucet_id });
const update_available = () => {
  niq_faucet.available().then(available => {
    document.getElementById("available").innerText = "Available: " + formatMoney(Number(available)/10**6, 3) + " NIQ";
  });
};
update_available();
setInterval(update_available, 10*1000);
document.getElementById("clickMeBtn").addEventListener("click", async () => {
  document.getElementById("form").style.display = "none";
  document.getElementById("response").style.color = "black";
  document.getElementById("response").innerText = "Loading... please wait";
  const principal = document.getElementById("principal").value.toString();
  niq_faucet.draw_many(principal).then(response => {
    console.log(response);
    if (response.hasOwnProperty('err')) {
      document.getElementById("response").style.color = "red";
      document.getElementById("response").innerText = response.err;
    } else {
      document.getElementById("response").innerText = "We just sent you 20,000 NIQ!";
    };
  }).catch(e => {
    console.log(e);
    document.getElementById("response").style.color = "red";
    document.getElementById("response").innerText = "Hm, there was an error - you most likely didn't enter a valid principal!";
  }).finally(() => {
    document.getElementById("form").style.display = "block";
    update_available();
  });
});

